import { createContext, useContext } from 'react';
import { TenantInformationCommandActions } from '../../domain';
import { GqlTenantInformationCommandActions } from '../gql';

type TenantInformationActionsContextT = {
  tenantInformationCommandActions: TenantInformationCommandActions;
};

export const tenantInformationDefaultValue: TenantInformationActionsContextT = {
  tenantInformationCommandActions: GqlTenantInformationCommandActions,
};

export const tenantInformationActionsContext = createContext<TenantInformationActionsContextT>(tenantInformationDefaultValue);

export const useTenantInformationActions = (): TenantInformationActionsContextT => useContext(tenantInformationActionsContext);
